import { ageGenderConfig } from '@/lib/analytics/charts/instagram/ageGenderConfig';
import { citiesDistributionConfig } from '@/lib/analytics/charts/instagram/citiesDistributionConfig';
import { countriesDistributionConfig } from '@/lib/analytics/charts/instagram/countriesDistributionConfig';
//charts
import { followerGrowthConfig } from '@/lib/analytics/charts/instagram/followerGrowthHistory';
import { followersOnlineConfig } from '@/lib/analytics/charts/instagram/followersOnline';
import { gainedLostFollowersConfig } from '@/lib/analytics/charts/instagram/gainedLostFollowers';
import { reachedAudienceDemographicsDistributionConfig } from '@/lib/analytics/charts/instagram/reachedAudienceDemographicsDistribution';
import { followersEvolutionConfig } from '@/lib/analytics/kpis/instagram/followersEvolution';
import { followersEvolutionPercentageConfig } from '@/lib/analytics/kpis/instagram/followersEvolutionPercentage';
import { totalFollowersConfig } from '@/lib/analytics/kpis/instagram/totalFollowers';
import { SIZE_50 } from '@/lib/gridElements/size';

export const CommunityInstagram = [
    totalFollowersConfig,
    followersEvolutionConfig,
    followersEvolutionPercentageConfig,
    followerGrowthConfig,
    gainedLostFollowersConfig,
    reachedAudienceDemographicsDistributionConfig,
    { ...ageGenderConfig },
    { ...countriesDistributionConfig, size: SIZE_50 },
    { ...citiesDistributionConfig, size: SIZE_50 },
    followersOnlineConfig
];

export const requestInstagramParams = [
    // Followers KPIs
    ['followers', 'followers_evolution', 'followers_evolution_percentage'],
    // InstagramAccountMetrics
    ['followers_history', 'gained_lost_followers_history'],
    // InstagramCommunity
    [
        'ages_genders_distribution',
        'countries_distribution',
        'cities_distribution',
        'reached_audience_demographics_distribution'
    ],
    // Followers Online
    ['followers_online']
];
